import { computed, Injectable, Signal, signal } from '@angular/core';
import { Application } from '../../shared/models/application';

@Injectable({
  providedIn: 'root',
})
export class LastUsedApplicationService {
  public appCodes = signal<Application[] | undefined>(undefined);

  readonly lastUsedApplications: Signal<Application[]> = computed(() => {
    const APP_CODES = this.appCodes();
    if (!APP_CODES) {
      return [];
    }

    return APP_CODES.map((app) => Application.fromDto(app));
  });
}
